import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useRef, useState } from "react";
import { InputNumber } from "primereact/inputnumber";
import { Toast } from "primereact/toast";
import editUserServices from "../../services/edit-users/edit-users.service";

interface DataTableProps {
    data: any[];
    year: number;
    month: number;
}

const CEtargetMappingListDataTable: React.FC<DataTableProps> = ({ data, year, month }) => {
    const toast = useRef<Toast>(null);
    const [ceDataList, setCeDataList] = useState<any[]>([]);
    const [totalTarget, setTotalTarget] = useState<number>(0);

    useEffect(() => {
        setCeDataList(data);

        const total = data?.reduce((sum, row) => sum + (parseFloat(row.salesTarget) || 0), 0);
        setTotalTarget(total);
    }, [data]);

    const formatCurrency = (value: number) => {
        return value.toLocaleString("en-IN", { style: "currency", currency: "INR" });
    };

    const targetEditor = (options: any) => {
        return (
            <InputNumber
                value={options.value}
                onValueChange={(e: any) => options.editorCallback(e.value, options.index)}
                mode="currency"
                currency="INR"
                locale="en-IN"
                min={0}
            />
        );
    };

    const onRowEditComplete = (e: any) => {
        const _data = [...ceDataList];
        const { newData, index } = e;

        _data[index] = newData;

        editUserServices.updateSalesExecutiveTarget({
            salesExecutiveId: newData.userID,
            salesTarget: newData.salesTarget,
            salesYear: year,   // ✅ pass from parent
            salesMonth: month  // ✅ pass from parent
        })
        .then(() => {
            setCeDataList(_data);

            const newTotal = _data.reduce((sum, row) => sum + (parseFloat(row.salesTarget) || 0), 0);
            setTotalTarget(newTotal);

            toast.current?.show({
                severity: "success",
                summary: "Success",
                detail: "Target updated successfully",
                life: 3000
            });
        })
        .catch(() => {
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Failed to update target",
                life: 3000
            });
        });
    };

    const targetBodyTemplate = (rowData: any) => formatCurrency(rowData.salesTarget);

    return (
        <>
            <Toast ref={toast} />
            <div className="col-12 card border-noround p-2">
                <DataTable
                    value={ceDataList}
                    editMode="row"
                    onRowEditComplete={onRowEditComplete}
                    paginator
                    rows={10}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    stripedRows
                    showGridlines
                    emptyMessage="No data found."
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                >
                    <Column
                        field="name"
                        header="Name"
                        style={{ width: "25%" }}
                        footer="Total:"
                    />
                    <Column
                        field="salesTarget"
                        header="Target"
                        editor={(options) => targetEditor(options)}
                        body={targetBodyTemplate}
                        style={{ width: "25%" }}
                        footer={formatCurrency(totalTarget)}
                    />
                    <Column
                        rowEditor
                        header="Action"
                        headerStyle={{ width: "15%", minWidth: "8rem" }}
                        bodyStyle={{ textAlign: "center" }}
                    />
                </DataTable>
            </div>
        </>
    );
};

export default CEtargetMappingListDataTable;
